import React, { useRef } from "react";
import nairobi from "../../assets/all-images/nairobi.png"
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { Container, Row, Col } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";

const navLinks = [
  {
    path: "/home",
    display: "Home",
  },
  {
    path: "/about",
    display: "About",
  },
  {
    path: "/services",
    display: "Services",
  },
  
  {
    path: "/cars",
    display: "Cars",
  },

  {
    path: "/blogs",
    display: "Blog",
  },
  {
    path: "/contact",
    display: "Contact",
  },
  {
    path: "/faq",
    display: "FAQ",
  },
  
  
  
];


const Header = () => {
  const menuRef = useRef(null);

  const toggleMenu = () => menuRef.current.classList.toggle("menu__active");

  return (
    <header className="header">
    <div className="header__top">
  <Container>
    <Row className="align-items-center">
      <Col lg="6" md="6" sm="6">
        <div className="header__top__left">
          <span>
            <Link to="/faq" className="no-underline text-white">Need Help?</Link>
          </span>
          <span className="header__top__help">
            <i className="ri-phone-fill"></i> +(254)7023456789
          </span>
        </div>
      </Col>

      <Col lg="6" md="6" sm="6">
        <div className="header__top__right d-flex align-items-center justify-content-end">
          <p className="m-0 me-3">Follow us on :</p>
          <div className="social-icons d-flex align-items-center gap-3">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
              <FaFacebookF  size={15} />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
              <FaXTwitter size={15} />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
              <FaInstagram  size={16} />
            </a>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</div>

      {/* =============== header middle =========== */}
      <div className="header__middle">
        <Container>
          <Row>
            <Col lg="4" md="3" sm="4">
              <div className="logo">
                <h1>
                  <Link to="/home" className=" d-flex align-items-center gap-2">
                    <i class="ri-car-line"></i>
                    <span>
                      Aspect Car Rent<br/>Services
                    </span>
                  </Link>
                </h1>
              </div>
            </Col>

            <Col lg="3" md="3" sm="4">
  <div className="header__location d-flex align-items-center gap-2">
    <img src={nairobi} alt="Kenya" style={{ width: '100px', height: 'auto' }} />
    <div className="header__location-content">
      <h4>Location</h4>
      <h6>Nairobi CBD, Nairobi</h6>
    </div>
  </div>
</Col>


            <Col lg="3" md="3" sm="4">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i class="ri-time-line"></i>
                </span>
                <div className="header__location-content">
                  <h4>Monday to Saturday</h4>
                  <h6>10am - 7pm</h6>
                </div>
              </div>
            </Col>

            <Col
              lg="2"
              md="3"
              sm="0"
              className=" d-flex align-items-center justify-content-end "
            >
              <button className="header__btn btn ">
                <Link to="/contact">
                  <i class="ri-phone-line"></i> Request a call
                </Link>
              </button>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ========== main navigation =========== */}

      <div className="main__navbar ">
        <Container>
          <div className="navigation__wrapper d-flex align-items-center justify-content-between">
            <span className="mobile__menu">
              <i class="ri-menu-line" onClick={toggleMenu}></i>
            </span>

            <div className="navigation" ref={menuRef} onClick={toggleMenu}>
              <div className="menu">
                {navLinks.map((item, index) => (
                  <NavLink
                    to={item.path}
                    className={(navClass) =>
                      navClass.isActive ? "nav__active nav__item" : "nav__item"
                    }
                    key={index}
                  >
                    {item.display}
                  </NavLink>
                ))}
              </div>
            </div>

          
            <Container>
          <Row>
           

            <Col lg="6" md="6" sm="6">
              <div className="header__top__right d-flex align-items-center justify-content-center gap-3">
                <Link to="/login" className=" d-flex align-items-center gap-1">
                  <i class="ri-login-circle-line"></i> Login
                </Link>

                <Link to="/signup" className=" d-flex align-items-center gap-1">
                  <i class="ri-user-line"></i> Signup
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
         
          </div>
        </Container>
      </div>
    </header>
  );
};

export default Header;
